import { useEffect, useState } from "@wordpress/element";

import "./style.scss";

type AirPollutionProps = {
	index?: number;
};

export const AirPollution = ({ index }: AirPollutionProps) => {
	const [color, setColor] = useState<string | undefined>("");

	useEffect(() => {
		if (index === undefined) {
			setColor(undefined);
			return;
		}

		switch (index) {
			case 0:
				setColor("var(--wp--preset--color--status-good)");
				break;
			case 1:
				setColor("var(--wp--preset--color--status-moderate)");
				break;
			case 2:
				setColor("var(--wp--preset--color--status-unhealthy)");
				break;
			case 3:
				setColor("var(--wp--preset--color--status-severe)");
				break;
			default:
				setColor(undefined);
		}
	}, [index]);

	return index === undefined ? (
		<p>-</p>
	) : (
		<span style={{ backgroundColor: color }} className="air-pollution"></span>
	);
};

export default AirPollution;
